import { render, staticRenderFns } from "./action-button.component.vue?vue&type=template&id=b7ff610c&scoped=true&"
import script from "./action-button.component.vue?vue&type=script&lang=ts&"
export * from "./action-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./action-button.component.vue?vue&type=style&index=0&id=b7ff610c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ff610c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
